/* German accessibility labels for Searchanise. Visible copy is managed in the app. */
(function () {
  'use strict';
  if (!/^de(?:-|$)/i.test(document.documentElement.lang)) return;
  var labels = {
    'Sort options': 'Sortieroptionen',
    'Sort by': 'Sortieren nach',
    'View grid mode': 'Rasteransicht anzeigen',
    'View list mode': 'Listenansicht anzeigen',
    'Close modal': 'Dialog schließen',
    'Close': 'Schließen',
    'Back': 'Zurück',
    'Clear': 'Suchfeld leeren',
    'Instant Search Results': 'Sofortige Suchergebnisse',
    'Search Results': 'Suchergebnisse',
    'Pagination': 'Seitennavigation',
    'Previous page': 'Vorherige Seite',
    'Next page': 'Nächste Seite',
    'Minimum value': 'Mindestpreis',
    'Maximum value': 'Höchstpreis',
    'Rating': 'Bewertung'
  };
  var tabs = { Products: 'Produkte', Produkte: 'Produkte', Categories: 'Kategorien', Kategorien: 'Kategorien', Pages: 'Seiten', Seiten: 'Seiten' };
  var attributes = ['aria-label', 'title'];
  var priceLabel = 'label.snize-visually-hidden[for^="snize-range-"]';
  var selector = '[aria-label], [title], ' + priceLabel;
  function isAppElement(element) {
    // Do not treat Searchanise's global body classes as a widget boundary.
    for (var node = element; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
      if (/^snize[-_]/.test(node.id || '') || /(?:^|\s)snize-/.test(node.getAttribute('class') || '')) return true;
    }
    return false;
  }
  function translate(element) {
    if (!isAppElement(element)) return;
    // Product names, descriptions, choices and stock data belong to the catalogue.
    if (element.closest('.snize-product') || element.matches('.snize-product-filters-checkbox, .snize-title, .snize-description, .snize-view-link')) return;
    if (element.matches(priceLabel)) {
      Array.prototype.forEach.call(element.childNodes, function (node) {
        if (node.nodeType !== 3) return;
        var value = node.nodeValue.trim();
        if (value === 'Minimum value' || value === 'Maximum value') node.nodeValue = node.nodeValue.replace(value, labels[value]);
      });
    }
    attributes.forEach(function (attribute) {
      var old = element.getAttribute(attribute);
      if (!old) return;
      var value = old.trim(), translated = Object.prototype.hasOwnProperty.call(labels, value) ? labels[value] : null, match;
      if (!translated && (match = /^Page (\d+)$/.exec(value))) translated = 'Seite ' + match[1];
      if (!translated && (match = /^View (Products|Produkte|Categories|Kategorien|Pages|Seiten) Tab$/.exec(value))) translated = tabs[match[1]] + ' anzeigen';
      if (translated && translated !== old) element.setAttribute(attribute, translated);
    });
  }
  function scan(root) {
    if (root.nodeType === 1) translate(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll(selector), translate);
  }
  function init() {
    var pending = new Set(), scheduled = false;
    function queue(root) {
      pending.add(root);
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        var roots = Array.from(pending);
        pending.clear();
        roots.forEach(function (root) { if (root.isConnected) scan(root); });
      });
    }
    // The app creates and replaces widgets after DOMContentLoaded, including mobile overlays.
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') queue(record.target);
        else if (record.type === 'characterData') {
          if (record.target.parentElement && record.target.parentElement.matches(priceLabel)) queue(record.target.parentElement);
        } else {
          Array.prototype.forEach.call(record.addedNodes, function (node) { if (node.nodeType === 1) queue(node); });
          if (record.target.nodeType === 1 && record.target.matches(priceLabel)) queue(record.target);
        }
      });
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes });
    scan(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();